import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import { ArticleContext } from '~/contexts/ArticleContext';
import AuthorImage from '~/components/Shared/AuthorImage/AuthorImage';
import { getArticleAuthors } from '~/utilities/getArticleAuthors';
import { getCSSColorText } from '~/utilities/getCSS';
import { formatDateForDisplay } from '~/utilities/formatDateForDisplay';

const authorNameClasses = cva('font-bigger text-xl mb-1', {
  variants: {
    color: getCSSColorText(),
  },
});

export default component$((): JSX.Element => {
  const {
    payloadToSSR: { editionEndpoint },
    themeComponents: { authorBio },
  } = useContext(AppDataContext);
  const article = useContext(ArticleContext);
  if (!article) return <></>;

  const authors = getArticleAuthors(
    article.authors,
    article.metadata?.hideOwner
  );

  return (
    <div class='w-full mb-8 lg:w-auto lg:absolute lg:top-0 lg:left-10 flex flex-col gap-1 items-center'>
      {authors.map((each, index) => {
        const authorLink =
          each.link ?? `https://${editionEndpoint}${each.pagePath}`;

        return (
          <div key={index}>
            <a
              data-testtype='author-link'
              class='flex flex-col gap-4 items-center'
              href={authorLink}
            >
              <AuthorImage
                widthClass='kyiv'
                image={{
                  ...each.authorInfo.image.value,
                  aspectRatio: { x: 180, y: 180 },
                }}
                isRounded
              />
              <span class='flex flex-col items-center'>
                <span
                  class={authorNameClasses({
                    color: authorBio.linkInTextColor.value,
                  })}
                >
                  {each.name}
                </span>
                {each.authorInfo.byline?.value && (
                  <span class='text-xs font-bold text-grey'>
                    {each.authorInfo.byline.value}
                  </span>
                )}
              </span>
            </a>
          </div>
        );
      })}
      <hr class='w-full max-w-[120px] h-[1px] bg-lightGrey' />
      <span class='font-bigger text-sm text-grey'>
        <time dateTime={article.createdAt}>
          {formatDateForDisplay(article.createdAt || '')}
        </time>
      </span>
    </div>
  );
});
